export default [
  {
    name: "JournalDetails"
  }
];
